import { render } from "./clinics-doctors-report.vue?vue&type=template&id=61bd61ac&scoped=true"
import script from "./clinics-doctors-report.vue?vue&type=script&lang=js"
export * from "./clinics-doctors-report.vue?vue&type=script&lang=js"

import "./clinics-doctors-report.vue?vue&type=style&index=0&id=61bd61ac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61bd61ac"]])

export default __exports__